import { InsureIQPolicyTypes } from '@harvestiq/constants';
import { DbTimestampGenerated, DbTimestampNullable } from '@harvestiq/utils';
import { zTimestamp } from '@harvestiq/zod';
import { expectTypeOf } from 'expect-type';
import { GeneratedAlways, Insertable, Selectable, Updateable } from 'kysely';
import { z } from '@harvestiq/zod';

export interface ClaimsTable {
  id: GeneratedAlways<string>;
  endorsementId: string;
  endorsementType: InsureIQPolicyTypes;
  claimNumber: string | null;
  notes: string | null;
  createdAt: DbTimestampGenerated;
  updatedAt: DbTimestampGenerated;
  deletedAt: DbTimestampNullable;
}

export type DbClaim = Selectable<ClaimsTable>;
export type DbClaimInsert = Insertable<ClaimsTable>;
export type DbClaimUpdate = Updateable<ClaimsTable>;

export const dbClaimSchema = z.object({
  id: z.string().uuid(),
  endorsementId: z.string().uuid(),
  endorsementType: z.nativeEnum(InsureIQPolicyTypes),
  claimNumber: z.string().nullable(),
  notes: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
});
expectTypeOf<DbClaim>().toMatchTypeOf<z.output<typeof dbClaimSchema>>();

export const dbClaimInsertSchema = dbClaimSchema
  .omit({
    id: true,
  })
  .partial()
  .extend({
    endorsementId: z.string().uuid(),
    endorsementType: z.nativeEnum(InsureIQPolicyTypes),
    createdAt: zTimestamp().optional(),
    updatedAt: zTimestamp().optional(),
    deletedAt: zTimestamp().nullable().optional(),
  });
type CreateClaimFromSchema = z.input<typeof dbClaimInsertSchema>;
expectTypeOf<keyof CreateClaimFromSchema>().toEqualTypeOf<
  keyof DbClaimInsert
>();
expectTypeOf<CreateClaimFromSchema>().toMatchTypeOf<DbClaimInsert>();

export const dbClaimUpdateSchema = dbClaimInsertSchema.partial();
type UpdateClaimFromSchema = z.input<typeof dbClaimUpdateSchema>;
expectTypeOf<keyof UpdateClaimFromSchema>().toEqualTypeOf<
  keyof DbClaimUpdate
>();
expectTypeOf<UpdateClaimFromSchema>().toMatchTypeOf<DbClaimUpdate>();
